import React from "react";

/**
 * Aegis One monogram. Minimal shield with an "A" cut, hivemapper-clean.
 */
export default function AegisLogo({ size = 32 }) {
    const s = size;
    return (
        <svg
            width={s}
            height={s}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-label="Aegis One"
        >
            <defs>
                <linearGradient id="aone-g" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#2563EB" />
                    <stop offset="1" stopColor="#00E5FF" />
                </linearGradient>
            </defs>
            {/* Rounded shield mark */}
            <path
                d="M20 3 L34 8 V22 C34 30 27.5 34.5 20 37 C12.5 34.5 6 30 6 22 V8 Z"
                fill="url(#aone-g)"
            />
            {/* Inner A */}
            <path
                d="M20 12 L25.5 26 H22.6 L21.6 23.2 H18.4 L17.4 26 H14.5 L20 12 Z M20 17 L19 21 H21 L20 17 Z"
                fill="#FFFFFF"
            />
        </svg>
    );
}
